import { useState, memo } from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaXTwitter,
  FaBars,
  FaXmark,
} from "react-icons/fa6";
import { Link, NavLink } from "react-router-dom";

/* ================= DATA ================= */
const navLinks = [
  { name: "Home", href: "/" },
  { name: "Services", href: "/services" },
  { name: "About", href: "/about" }, // ✅ important
  { name: "Contact", href: "/contact" },
  { name: "Blog", href: "/blog" },
  { name: "Careers", href: "/careers" },

];

const socialLinks = [
  { icon: FaFacebookF, label: "Facebook", href: "https://www.facebook.com/profile.php?id=61568699487730" },
  { icon: FaInstagram, label: "Instagram", href: "https://www.instagram.com/maxzen_hr_services/" },
  { icon: FaLinkedinIn, label: "LinkedIn", href: "https://www.linkedin.com/company/maxzen-hr-services/?viewAsMember=true" },
  { icon: FaXTwitter, label: "Twitter", href: "https://x.com/maxzenhrservice" },
];

/* ================= SOCIAL ICON ================= */
const SocialIcon = memo(({ Icon, label, href }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    aria-label={label}
    className="w-8 h-8 flex items-center justify-center border rounded-full hover:bg-white focus:outline-none focus:ring-2 focus:ring-black"
  >
    <Icon size={14} aria-hidden="true" />
  </a>
));

/* ================= NAVBAR ================= */
export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="bg-[#a78bfa] w-full">
      {/* TOP BAR */}
      <div className="max-w-6xl mx-auto flex justify-between items-center py-4 px-6 text-sm">

        {/* LOGO */}
        <Link to="/" className="flex items-center gap-2">
          <img
            src="/maxzenlogo.webp"
            alt="Maxzen HR Services company logo"
            loading="eager"
            width="120"
            height="80"
            className="h-8 md:h-20 w-auto object-contain"
          />
          <span className="text-lg md:text-xl font-semibold text-black">
            Maxzen HR Services Pvt. Ltd.
          </span>
        </Link>

        {/* RIGHT (DESKTOP SOCIAL) */}
        <div className="hidden md:flex items-center gap-6">
          <span className="text-black">Follow Us:</span>
          <div className="flex gap-2">
            {socialLinks.map(({ icon: Icon, label, href }) => (
              <SocialIcon key={label} Icon={Icon} label={label} href={href} />
            ))}
          </div>
        </div>

        {/* HAMBURGER */}
        <button
          className="md:hidden focus:outline-none focus:ring-2 focus:ring-black"
          aria-label="Toggle navigation menu"
          aria-expanded={isOpen}
          aria-controls="mobile-menu"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          {isOpen ? <FaXmark size={20} /> : <FaBars size={20} />}
        </button>
      </div>

      {/* DIVIDER */}
      <div className="max-w-6xl mx-auto border-t border-black" />

      {/* DESKTOP NAV */}
      <nav
        className="max-w-6xl mx-auto hidden md:flex justify-end items-center py-4 px-6 gap-10"
        aria-label="Main navigation"
      >
        <ul className="flex items-center gap-8 text-lg">
          {navLinks.map((link) => (
            <li key={link.name}>
              <NavLink
                to={link.href}
                className={({ isActive }) =>
  `text-black hover:text-white focus:outline-none focus:ring-2 focus:ring-black ${
    isActive ? "text-white font-semibold" : ""
  }`
}
              >
                {link.name}
              </NavLink>
            </li>
          ))}
        </ul>

        {/* ✅ FIXED BUTTON */}
        <Link
          to="/contact"
          className="px-6 py-2 border border-black rounded-full text-black hover:bg-white transition focus:outline-none focus:ring-2 focus:ring-black"
        >
          Get Started
        </Link>
      </nav>

      {/* MOBILE MENU */}
      {isOpen && (
        <nav
          id="mobile-menu"
          className="md:hidden px-6 py-4 space-y-4 bg-[#c5bbff]"
          aria-label="Mobile navigation"
        >
          <ul className="space-y-3">
            {navLinks.map((link) => (
              <li key={link.name}>
                <NavLink
                  to={link.href}
                  onClick={() => setIsOpen(false)}
                  className={({ isActive }) =>
  `block text-black hover:text-orange-500 ${
    isActive ? "text-orange-500 font-semibold" : ""
  }`
}
                >
                  {link.name}
                </NavLink>
              </li>
            ))}
          </ul>

          {/* ✅ FIXED BUTTON */}
          <Link
            to="/contact"
            className="block text-center w-full px-6 py-2 border border-black rounded-full mt-2 focus:outline-none focus:ring-2 focus:ring-black"
            onClick={() => setIsOpen(false)}
          >
            Get Started
          </Link>

          {/* SOCIAL */}
          <div className="flex gap-3 pt-3">
            {socialLinks.map(({ icon: Icon, label, href }) => (
              <SocialIcon key={label} Icon={Icon} label={label} href={href} />
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}